module.exports = __webpack_public_path__ + "img/4b66b1c.jpeg";